import { ReactComponent as IconPin } from "assets/images/icons/pin-white.svg";
import BulletinBoardTeaser from "features/bulletins/components/BulletinBoardTeaser";
import Panel from "pages/Dashboard/Panel";
import useViewData from "features/view/hooks/useViewData";
import Alert from "components/ui/Alert/Alert";

function LastRepliesPanel() {
  const { view, isLoading } = useViewData('comment/summary');

  if (isLoading) {
    return null;
  }

  if (view?.results?.length === 0) {
    return null;
  }

  let content;
  if (view?.results) {
    content = view.results.map(data => <BulletinBoardTeaser key={ data.id } data={ data }/>);
  } else {
    content = <Alert message={ `Het ophalen van de reacties is mislukt.` }/>;
  }

  return (
    <Panel title={ 'Laatste reacties' }
           id={ 'last-replies' }
           showAllPath={ '/prikbord/mijn-prikbord' }
           linkLabel={ 'Mijn prikbord' }
           icon={ <IconPin/> }
           hasContentBackground={ true }>
      { content }
    </Panel>
  );
}

export default LastRepliesPanel;
